module.exports = __webpack_public_path__ + "static/media/AU 2017 Research Roster.51666c92.csv";